import React from 'react';
import window from 'window-or-global';
import PropTypes from 'prop-types';
import { createRoot } from 'react-dom/client';

import { getSessionData } from '@confluence/session-data/entry-points/SessionData';

import { SessionDataContext } from '@confluence/session-data/entry-points/SessionDataContext';
import { ChoreographerAssetsContextProvider } from '@confluence/choreographer-services/entry-points/ChoreographerAssetsContext';

import ComponentWrapper from '../ComponentWrapper';
import configureStore from '../../../stores/configureStore';
import { subscribe } from '../../../subscriptions';

const store = configureStore({ isServerRenderedPage: true });
subscribe(store);

const context = {
	insertCss: (styles) => styles._insertCss(),
};

/**
 * Method for rendering React/Redux component
 * Usage:
 * import renderComponent from './renderComponentIntoDOM';
 * renderComponent(<YourComponent />, 'your-component-section-id');
 * OR renderComponent(<YourComponent />, DOMComponent);
 *
 * @param children
 * @param container DOM node or id string
 */
const renderComponentIntoDOM = (children, container, renderAsRoot = false) => {
	if (typeof container === 'string') {
		container = window.document.getElementById(container);
	}

	const Component = ({ sessionData }) => (
		<SessionDataContext.Provider value={sessionData}>
			<ChoreographerAssetsContextProvider>
				<ComponentWrapper store={store} context={context} renderAsRoot={renderAsRoot}>
					{children}
				</ComponentWrapper>
			</ChoreographerAssetsContextProvider>
		</SessionDataContext.Provider>
	);

	Component.propTypes = {
		sessionData: PropTypes.object.isRequired,
	};

	getSessionData().then((sessionData) => {
		const concurrentComponentWrapper = createRoot(container);
		concurrentComponentWrapper.render(<Component sessionData={sessionData} />);
	});
};

export default renderComponentIntoDOM;
